import React from "react"
import "./footer.css"
import { useLanguage } from "../../../context/LanguageContext"

const Footer = () => {
  const { content } = useLanguage()
  const { footer, assets, header } = content

  return (
    <>
      <section className='footerContact'>
        <div className='container'>
          <div className='send flex'>
            <div className='text'>
              <h1>{footer.contactTitle}</h1>
              <p>{footer.contactSubtitle}</p>
            </div>
            <button type='button' className='btn5'>
              {footer.contactButton}
            </button>
          </div>
        </div>
      </section>

      <footer>
        <div className='container'>
          <div className='box'>
            <div className='logo'>
              <img src={assets.logoLight} alt={header.logoAlt} />
              <h2>{footer.newsletterTitle}</h2>
              <p>{footer.newsletterText}</p>

              <div className='input flex'>
                <input type='text' placeholder={footer.newsletterPlaceholder} />
                <button type='button'>{footer.newsletterButton}</button>
              </div>
            </div>
          </div>

          {footer.sections.map((val) => (
            <div className='box' key={val.title}>
              <h3>{val.title}</h3>
              <ul>
                {val.text.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </footer>
      <div className='legal'>
        <span>{footer.legal}</span>
      </div>
    </>
  )
}

export default Footer
